import React from 'react';
import { Button, Tooltip } from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import { MAX_GROUP_MAIL_RECIPIENTS, groupMailUrl } from './groupMail';

/**
 * Props for {@link GroupMailLink}.
 *
 * @public
 */
export type GroupMailLinkProps = {
  /** The email addresses of the list. */
  addresses: string[];
};

/**
 * Writes one email to everyone of a list. Shown for two people up to
 * {@link MAX_GROUP_MAIL_RECIPIENTS}: one person has an address of their own
 * on their card, and a longer list is left to a mailing list or a group.
 *
 * @public
 */
export const GroupMailLink = (props: Readonly<GroupMailLinkProps>) => {
  const addresses = [...new Set(props.addresses)];
  if (addresses.length < 2 || addresses.length > MAX_GROUP_MAIL_RECIPIENTS) {
    return null;
  }
  return (
    <Tooltip title={`Email all ${addresses.length} people`}>
      <Button
        size="small"
        href={groupMailUrl(addresses)}
        startIcon={<EmailIcon fontSize="small" />}
      >
        Email all
      </Button>
    </Tooltip>
  );
};
